import React from 'react';
import {Mesures, TypesMesures} from "../../../../Shared/Enums/Enums";
import MesureOverview from "../MesureOverview";
import {t} from "../../../../I18n/i18n"

const Measures = ({appointment}) => {
    const sortedMesures = appointment.mesures ?
        Object.values(TypesMesures)
            .map((type) => appointment.mesures.find((m) => m.typedemesure.titre === type))
            .filter((m) => m)
        : [];

    return <div>
        <h6 style={{fontWeight: "bolder"}}>{t("MEASURES")} :</h6>
        <table>
            <tbody>
            {sortedMesures.map(mesure => {
                let type = ""
                if (mesure.typedemesure.titre === TypesMesures.TENSION) type = Mesures.TENSION.value
                if (mesure.typedemesure.titre === TypesMesures.PACHYMETRY) type = Mesures.PACHYMETRY.value
                return <tr>
                    <td style={{fontSize: 12, padding: 0}}>{mesure.typedemesure.titre}</td>
                    <td style={{fontSize: 12, padding: 5}}><MesureOverview mesure={mesure} type={{name: type}}/>
                    </td>
                </tr>

            })}
            </tbody>
        </table>
    </div>
}

export default Measures;